import { DismissablePromptKey, Experiment } from '@ms/yammer-data/dist/state/types';
import {
  useIsDataLoaded,
  useIsPromptDismissed,
  useLoadDismissablePrompts,
} from '@ms/yammer-hooks/dist/dismissablePrompts';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

const promptType = DismissablePromptKey.VivaEngageRebrandingBanner;

export const useShouldDisplayVivaEngageRebrandingBanner = () => {
  useLoadDismissablePrompts([promptType]);

  const isDataLoaded = useIsDataLoaded(promptType);
  const isDismissed = useIsPromptDismissed(promptType);
  const isExperimentEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.VivaEngageRebrandingBanner) === 'enabled';

  if (!isDataLoaded || !isExperimentEnabled) {
    return false;
  }

  return !isDismissed;
};
